import { render, staticRenderFns } from "./VSpeechToText.vue?vue&type=template&id=a62a4a7c&"
import script from "./VSpeechToText.vue?vue&type=script&lang=js&"
export * from "./VSpeechToText.vue?vue&type=script&lang=js&"
import style0 from "./VSpeechToText.vue?vue&type=style&index=0&id=a62a4a7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports